// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__KMeeG","paddingTop":"Main_paddingTop__Yvl96","spacing-extra":"Main_spacing-extra__k8apP"};